import { render, staticRenderFns } from "./learnLesson.vue?vue&type=template&id=4566cf2c&scoped=true"
import script from "./learnLesson.vue?vue&type=script&lang=js"
export * from "./learnLesson.vue?vue&type=script&lang=js"
import style0 from "./learnLesson.vue?vue&type=style&index=0&id=4566cf2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4566cf2c",
  null
  
)

export default component.exports